import { t } from "@/language/translation";
import { computed } from "vue";
import {
  EisenhowerPriority,
  type Maybe,
  type Scalars,
  SQDCBoardIssueConnectionTypes,
} from "@/graphql";

export type BoardEventConnectionType = {
  createdAt: Scalars["Date"]["output"];
  status: SQDCBoardIssueConnectionTypes;
  reason?: Maybe<Scalars["String"]["output"]>;
};

export enum AbstractIssueModalComponentFields {
  description = "description",
  date = "date",
  owner = "owner",
  flags = "flags",
  creator = "creator",
  eisenhowerPriority = "eisenhowerPriority",
}

export function getEisenhowerIconClass(priority: EisenhowerPriority | undefined) {
  switch (priority) {
    case EisenhowerPriority.DO:
      return "fa-solid fa-bolt";
    case EisenhowerPriority.SCHEDULE:
      return "fas fa-calendar";
    case EisenhowerPriority.DELEGATE:
      return "fas fa-user-plus";
    case EisenhowerPriority.DELETE:
      return "fas fa-trash-alt";
    case EisenhowerPriority.NO_PRIORITY:
    default:
      return "fa-solid fa-ban";
  }
}

export const eisenhowerOptions = computed(() => {
  return [
    {
      label: t(`components.eventAction.filter.badges.PriorityFilter.DO`),
      value: EisenhowerPriority.DO,
      icon: "fa-solid fa-bolt",
    },
    {
      label: t(`components.eventAction.filter.badges.PriorityFilter.SCHEDULE`),
      value: EisenhowerPriority.SCHEDULE,
      icon: "fas fa-calendar",
    },
    {
      label: t(`components.eventAction.filter.badges.PriorityFilter.DELEGATE`),
      value: EisenhowerPriority.DELEGATE,
      icon: "fas fa-user-plus",
    },
    {
      label: t(`components.eventAction.filter.badges.PriorityFilter.DELETE`),
      value: EisenhowerPriority.DELETE,
      icon: "fas fa-trash-alt",
    },
    {
      label: t(`components.eventAction.filter.badges.PriorityFilter.noPriority`),
      value: EisenhowerPriority.NO_PRIORITY,
      icon: "fa-solid fa-ban",
    },
  ];
});

export function getEisenhowerClass(modelValue: EisenhowerPriority | undefined) {
  switch (modelValue) {
    case EisenhowerPriority.DO:
      return "Eisenhower-DO";
    case EisenhowerPriority.SCHEDULE:
      return "Eisenhower-SCHEDULE";
    case EisenhowerPriority.DELEGATE:
      return "Eisenhower-DELEGATE";
    case EisenhowerPriority.DELETE:
      return "Eisenhower-DELETE";
    case EisenhowerPriority.NO_PRIORITY:
    default:
      return "Eisenhower-NO_PRIORITY";
  }
}

export function getEisenhowerColor(modelValue: EisenhowerPriority | undefined) {
  switch (modelValue) {
    case EisenhowerPriority.DO:
      return "var(--p-eisenhower-do-color)";
    case EisenhowerPriority.SCHEDULE:
      return "var(--p-eisenhower-schedule-color)";
    case EisenhowerPriority.DELEGATE:
      return "var(--p-eisenhower-delegate-color)";
    case EisenhowerPriority.DELETE:
      return "var(--p-eisenhower-delete-color)";
    case EisenhowerPriority.NO_PRIORITY:
    default:
      return "var(--p-disabled-color)";
  }
}
